import {ClientEnv} from "@FRAMEWORK/config/public";
import axios from "axios";

/** 로그인 후 복귀 URL이 현재 페이지와 같은지 */
const isSamePage = (nextUrl?: string) => {
	if (!nextUrl) return true;
	try {
		const dest = new URL(nextUrl, location.origin);
		return dest.pathname + dest.search === location.pathname + location.search;
	} catch {
		return nextUrl === location.pathname + location.search;
	}
};

/**
 * 로그인 관련 유틸
 */
class LoginUtil {
	#channelCode: string;
	#loginBaseUrl: string;
	#logoutBaseUrl: string;
	#desktopHost: string;
	#accountHost: string;
	#nonMemberUrl: string; /** 비회원 예약조회 파라미터 */
	#logoutApiPath: string;
	constructor(env: ClientEnv) {
		this.#desktopHost = env.ENV_PACKAGE_URL;
		this.#channelCode = "prdt001";
		this.#loginBaseUrl = `${env.ENV_ACCOUNTS_DOMAIN}/signIn`;
		this.#logoutBaseUrl = `${env.ENV_ACCOUNTS_DOMAIN}/signOut`;
		this.#accountHost = `${env.ENV_ACCOUNTS_DOMAIN}`;
		this.#nonMemberUrl = `${this.#desktopHost}/accounts/nonMemberReserveAuth.yb?channelCode=pkg002`;
		this.#logoutApiPath = `/acct/api/account/signOut`;
	}
	/** @description 로그인 */
	login(nextUrl?: string) {
		const {pathname, search} = location;
		sessionStorage.setItem("__LOGIN_NEXT", `${nextUrl || pathname + search}`);
		const originUrl = `${location.origin}/controller/login`;
		const signInUrl = `${this.#loginBaseUrl}?channelCode=${this.#channelCode}&returnUrl=${encodeURIComponent(originUrl)}`;
		// 같은 페이지로 돌아오는 로그인은 히스토리를 덮어써서 동일 URL이 쌓이지 않게 함
		if (isSamePage(nextUrl)) {
			window.location.replace(signInUrl);
			return;
		}
		window.location.href = signInUrl;
	}
	/**
	 * @description 회원가입
	 */
	siginUp() {
		window.location.href = `${this.#accountHost}/signUp`;
	}
	/** @description 로그인(회원 / 비회원예약) — prdt 세션 생성 후 returnUrl로 SSO */
	loginRsvn(nextUrl?: string) {
		const {origin, pathname, search} = location;
		const originUrl = `${origin}/controller/login`;
		sessionStorage.setItem("__LOGIN_NEXT", `${nextUrl || pathname + search}`);
		window.location.href = `${this.#loginBaseUrl}?channelCode=${this.#channelCode}&pageType=reserve&returnUrl=${encodeURIComponent(
			`${originUrl}`,
		)}`;
	}
	/** @description 예약확인 - Desktop */
	rsvnConfirm() {
		window.location.href = `${this.#loginBaseUrl}?channelCode=${this.#channelCode}&returnUrl=${encodeURIComponent(
			this.#desktopHost,
		)}/mypage/resvInfo.yb&nonMemberUrl=${encodeURIComponent(this.#nonMemberUrl)}`;
	}
	/** @description 관심상품 - Desktop */
	wishConfirm() {
		window.location.href = `${this.#loginBaseUrl}?channelCode=${this.#channelCode}&returnUrl=${encodeURIComponent(
			this.#desktopHost,
		)}/mypage/wishGoods.yb`;
	}
	/** @description 로그아웃*/
	logout() {
		(async () => {
			await axios(this.#logoutApiPath);
			const signOutUrl = `${this.#logoutBaseUrl}?channelCode=${this.#channelCode}&returnUrl=${encodeURIComponent(
				window.location.href,
			)}`;
			// 같은 페이지로 돌아오는 로그아웃은 히스토리를 덮어써서 동일 URL이 쌓이지 않게 함
			window.location.replace(signOutUrl);
		})();
	}
}

export default LoginUtil;
